import * as ACTIONS from '../constants/environment';

export const setEnvironment = env => dispatch => {
  let drugId = '';
  let drugSelected = '';

  // to use on the API requests
  const enrollmentSource = 'API';
  const drugPatient = true;
  const coverageType = 'PHARMACY';
  const planType = 'PHARMACY';
  const source = 'ENROLLMENT';
  const type = 'PROVIDER';

  switch (env) {
    case 'ninlaro':
      drugId = 'f429786d-dfd2-4ca6-8499-075ad2afdcf2';
      drugSelected = 'ninlaro';
      break;
    case 'alunbrig':
      drugId = '9a112184-84ba-4e97-8823-c2ab1a11e59c';
      drugSelected = 'alunbrig';
      break;
    case 'iclusig':
      drugId = 'e10d1932-10da-4967-a70f-42ba1e2c1b7c';
      drugSelected = 'iclusig';
      break;
    case 'fruzaqla':
      drugId = '5727dfcf-3786-42de-a82c-a7ab5e34274d';
      drugSelected = 'fruzaqla';
      break;
    case 'mimrylo':
      drugId = '3a40fa97-a4c1-4b74-a6a3-7fb00cce61d5';
      drugSelected = 'mimrylo';
      break;
    default:
      drugId = '';
      drugSelected = '';
      break;
  }
  return dispatch({
    type: ACTIONS.ENVIRONMENT.SET,
    payload: {
      env,
      drugId,
      drugSelected,
      enrollmentSource,
      drugPatient,
      coverageType,
      planType,
      source,
      type,
    },
  });
};

export const clearEnvironment = () => dispatch => dispatch({
  type: ACTIONS.ENVIRONMENT.CLEAR,
  payload: {
    env: '',
  },
});
